<template>
  <div
    class="w-full h-full flex flex-col relative animate-fade-in"
    :class="theme.text"
  >
    <div class="shrink-0 h-12 flex items-center justify-between px-4 z-10">
      <button @click="$emit('back')">
        <icon-base
          name="ChevronLeft"
          class="w-6 h-6 opacity-60 hover:opacity-100"
        ></icon-base>
      </button>
      <span class="font-bold">{{ t.member_title }}</span>
      <div class="w-6"></div>
    </div>
    <div class="flex-1 overflow-y-auto px-4 pb-4">
      <div
        class="relative overflow-hidden rounded-2xl p-6 text-white mb-6 shadow-xl flex flex-col justify-between"
        :style="{ minHeight: isWatch ? '140px' : '180px' }"
      >
        <div
          class="absolute inset-0 bg-gradient-to-br from-slate-900 to-slate-800 z-0"
        ></div>
        <div
          class="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 z-0"
        ></div>
        <div
          class="absolute -right-10 -top-10 w-48 h-48 bg-amber-500/20 rounded-full blur-3xl"
        ></div>
        <div
          class="absolute -left-10 -bottom-10 w-32 h-32 bg-orange-500/10 rounded-full blur-2xl"
        ></div>
        <div class="relative z-10">
          <div class="flex justify-between items-start">
            <div>
              <div
                class="text-amber-400 font-bold tracking-widest text-[10px] mb-1"
              >
                PRO MEMBER
              </div>
              <div
                class="font-bold animate-shine"
                :class="isWatch ? 'text-2xl' : 'text-3xl'"
              >
                {{ t.banner_title }}
              </div>
            </div>
            <icon-base
              name="Crown"
              class="text-amber-400"
              :class="isWatch ? 'w-8 h-8' : 'w-10 h-10'"
            ></icon-base>
          </div>
        </div>
        <div class="relative z-10 text-xs text-slate-300 opacity-80">
          {{ t.unlock_desc }}
        </div>
      </div>
      <div class="space-y-3 mb-4">
        <div
          v-for="(item, i) in t.privileges"
          :key="i"
          class="flex gap-3 items-center"
        >
          <div
            class="w-6 h-6 rounded-full bg-amber-500/10 flex items-center justify-center shrink-0"
          >
            <icon-base name="Check" class="w-3 h-3 text-amber-500"></icon-base>
          </div>
          <div>
            <div class="text-sm font-bold">{{ item.t }}</div>
            <div v-if="!isWatch" class="text-xs opacity-50">{{ item.d }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="p-4 border-t safe-bottom"
      :class="
        theme.isDark
          ? 'border-white/10 bg-[#0f1115]'
          : 'border-black/5 bg-white'
      "
    >
      <button
        @click="$emit('upgrade')"
        class="w-full py-3 rounded-xl bg-gradient-to-r from-amber-400 to-orange-600 text-white font-bold text-base shadow-lg shadow-orange-500/20 active:scale-95 transition-all flex items-center justify-center gap-2"
      >
        <span>{{ t.pay_btn }}</span>
      </button>
      <div v-if="!isWatch" class="text-[9px] text-center opacity-40 mt-2">
        {{ t.pay_agreement }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme", "t", "device", "isPro"],
  computed: {
    isWatch() {
      return this.device === "WATCH";
    },
  },
};
</script>
